module.exports = __webpack_public_path__ + "static/media/vapr-orientation.3b95adb4.webp";


//////////////////
// WEBPACK FOOTER
// ./src/components/devicemanagement/vaprdevice/assets/vapr-orientation.webp
// module id = 1432
// module chunks = 0